import { render, staticRenderFns } from "./PriceReferences.vue?vue&type=template&id=77e7f254&scoped=true"
import script from "./PriceReferences.vue?vue&type=script&lang=js"
export * from "./PriceReferences.vue?vue&type=script&lang=js"
import style0 from "./PriceReferences.vue?vue&type=style&index=0&id=77e7f254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e7f254",
  null
  
)

export default component.exports